import { useState } from 'react'
import { useApiRestClient } from '../../providers/api-rest-client/api-rest-client'

export const useApiActionState = () => {
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState()
	const client = useApiRestClient()

	return { loading, setLoading, error, setError, client }
}
